import type { UserMetadata } from '@supabase/supabase-js'
import { isAuthError } from '@supabase/supabase-js'

type ContactType = 'email' | 'phone'

type ChangeAuthContactMutation = {
  mutateAsync: (input: {
    email?: string
    phone?: string
    metadata?: UserMetadata
  }) => Promise<boolean>
}

type OtpStateManager = {
  markOtpSent: (key: string) => void
}

export async function sendAuthContactOtp({
  contactType,
  contactValue,
  changeAuthContact,
  otpStateManager,
  metadata,
  onError,
}: {
  contactType: ContactType
  contactValue: string
  changeAuthContact: ChangeAuthContactMutation
  otpStateManager: OtpStateManager
  metadata?: UserMetadata
  onError?: (error: unknown) => void
}): Promise<boolean> {
  if (!contactValue) {
    return false
  }

  try {
    const sendProps =
      contactType === 'email'
        ? {
            email: contactValue,
          }
        : {
            phone: contactValue,
          }

    const result = await changeAuthContact.mutateAsync({
      ...sendProps,
      metadata,
    })

    if (result) {
      otpStateManager.markOtpSent(contactValue)
    }

    return result
  } catch (error) {
    console.error('Failed to send OTP:', error)

    if (isAuthError(error) && (error.code === 'phone_exists' || error.code === 'email_exists')) {
      throw error
    }

    if (onError) {
      onError(error)
    }

    return false
  }
}
